module.exports = __webpack_public_path__ + "static/logo-light-c6b78d99edbb475b25963fb9e24ac729.png";